import React from "react";
import "./BodyHeader.css";
import { ChangedData } from "../../../../assets/ChangedData/ChangedData";
import { allData } from "../../../../Screens/lebenslauf/Lebenslauf";







export const BodyHeader = (props) =>{
    const title = props.title;
    const idd = props.idd;





    const hoverEditOn = (event) => {
        if (localStorage.getItem("isLogged") == "true") {
            event.target.classList.add("editCursurOnHover");
        }
    }
    const hoverEditOut = (event) => {
        let TargetElement = event.target;
        let inn = TargetElement.classList[0];
        let toRemoveElement = document.querySelector("."+inn+" .EditLogoContainer");
        if (toRemoveElement){
            TargetElement.removeChild(toRemoveElement);
        }
    }

    const toTextEditFunction = (event) => {
        
        if (localStorage.getItem("isLogged") == "true") {
            let toTextEdit = event.target;
            let Oldtext = toTextEdit.innerText;
            let Classes = toTextEdit.classList;
            let width = toTextEdit.getBoundingClientRect().width;
            let height = toTextEdit.getBoundingClientRect().height;
            let id = toTextEdit.linke;
    
            toTextEdit.innerHTML = "";
            let textArea = document.createElement("textarea");
            toTextEdit.appendChild(textArea);
            textArea.classList.add("TextEditArea");
    
            for (let i = 0; i < Classes.length; i++) {
                textArea.classList.add(Classes[i]);
            }
    
            textArea.focus();
            textArea.value = Oldtext;
    
            textArea.style.width = width + 20 + "px";
            textArea.style.height = height + 10 + "px";
    

            toTextEdit.addEventListener("focusout" , ()=> {
                
                if ( textArea.value.length > 1) {
                    let NewValueTextarea = textArea.value
                    toTextEdit.innerHTML = NewValueTextarea;
                    // file name
                    let APIfileName = "CVsections";
                    // atribut name
                    let atributname = event.target.id;
                    // get text after chanched
                    let textafter = event.target.innerHTML;
                    let index = atributname.match(/\d+/g);

                    if (Oldtext != textafter) {
                        let SaveChangContainer = document.getElementById("SaveChangContainer");
                        SaveChangContainer.style.visibility = "visible";

                        allData.sec[index[0]].head.title = textafter;

                        if ( !ChangedData[APIfileName]) {
                            ChangedData[APIfileName] = allData;
                        }else{
                            ChangedData[APIfileName] = allData;
                        }
                    }
                }else{
                    // return old Text
                    toTextEdit.innerHTML = Oldtext;
                }
            });
            
            toTextEdit.addEventListener("keydown" , ()=> {
                textArea.style.width = "max-content";
                textArea.style.height = "max-content";
            });
        }
        
    }

    
    
    return(
        <div>
            <div className="BhbODYhEADER d-flex">
                <p className="BHMainTitl d-flex align-items-center" id={`headbi_${idd}`} onMouseOver={hoverEditOn} onMouseLeave={hoverEditOut} onClick={toTextEditFunction} >{title}</p>
            </div>
        
            
        </div>
    );
}